import { Footnote, theme } from '@acorns/web-components'
import styled from 'styled-components'

const IMAGE_WIDTH = 283
const IMAGE_HEIGHT = 223
const CARD_PADDING_Y = 30
const CARD_PADDING_X = 50

export const Container = styled.div`
  min-height: calc(100vh - 100px);

  @media screen and (min-width: ${theme.breakpoints.sm}px) {
    min-height: 600px;
    position: relative;
    padding-bottom: ${190 - CARD_PADDING_Y}px;
  }
`

export const Content = styled.div`
  position: relative;
  max-width: 400px;
  min-height: 700px;
  margin: 0 auto;
  z-index: 1;

  @media screen and (min-width: ${theme.breakpoints.sm}px) {
    min-height: 0;
  }
`

export const Title = styled.h2`
  color: ${theme.colors.slate};
  font-size: 40px;
  line-height: 55px;
  margin: 0;
  text-align: left;
  font-weight: 600;

  @media screen and (min-width: ${theme.breakpoints.sm}px) {
    margin: 30px 0 10px;
  }
`

export const Text = styled.p`
  color: ${theme.colors.slate};
  margin-bottom: 30px;
  text-align: left;
  font-size: 16px;
  line-height: 24px;
`

export const StyledFootnote = styled(Footnote)`
  margin-top: 30px;
  line-height: 16px;
`

export const StyledImage = styled.img`
  position: absolute;
  z-index: 0;
  right: 0;
  bottom: 0;
  width: ${IMAGE_WIDTH}px;
  height: ${IMAGE_HEIGHT}px;

  @media screen and (min-width: ${theme.breakpoints.sm}px) {
    border-bottom-right-radius: 10px;
    overflow: hidden;
    right: -${CARD_PADDING_X}px;
    bottom: -${CARD_PADDING_Y}px;
  }
`
